import { BidiModule } from '@angular/cdk/bidi';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BMSliderValueTooltipDirective } from './bm-slider-tooltip.directive';
import { BMSliderComponent } from './bm-slider.component';

@NgModule({
  imports: [BidiModule, CommonModule, OverlayModule],
  declarations: [BMSliderValueTooltipDirective, BMSliderComponent],
  exports: [BMSliderComponent, BMSliderValueTooltipDirective],
})
/**
 * Slider component module
 */
export class BMSliderComponentModule {}
